import type { FC } from 'react';
import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';
import { Iconify, Label } from '@pflegenavi/web-components';
import { useTranslation } from 'react-i18next';
import { InfoBoxContainer } from '../InfoBox';
import PaymentFailedImage from '../../../assets/undraw_payment_failed.svg';

export const DisabledPaymentInfoBox: FC = () => {
  return (
    <InfoBoxContainer
      image={
        <img
          src={PaymentFailedImage}
          alt=""
          width={210}
          style={{ marginTop: 30 }}
        />
      }
      content={<DisabledPaymentContent />}
    />
  );
};

const DisabledPaymentContent: FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <>
      <Label
        sx={{
          mb: 2,
          p: 1.8,
        }}
        variant="filled"
        color="error"
      >
        {t('mobile.family-member.disabled-payment')}
      </Label>
      <Stack direction="row" justifyContent="center">
        <Iconify
          icon="bxs:error"
          color={theme.palette.error.main}
          fontSize={25}
        />
        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 700,
            ml: 0.7,
          }}
        >
          {t('mobile.family-member.disabled-payment')}
        </Typography>
      </Stack>
      <Typography variant="subtitle1">
        {t('mobile.family-member.disabled-payment-contact-nursing-home')}
      </Typography>
    </>
  );
};
